import React, { useContext, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { userContext } from '../../../contextProvider/Authentication';
import { getDuration } from '../../../Functions/dates';
import axiosInstance from '../../../services/AxiosInstance';


function Jobsection() {

	const { authenticated, user } = useContext(userContext);
	const history = useHistory();

	const [jobs, setJobs] = useState([]);
	const [saved, setSaved] = useState([]);

	const date = jobs?.results?.[0]?.created_on

	useEffect(() => {
		getData();
		// eslint-disable-next-line
	}, [])

	const getData = (page = 1) => {
		axiosInstance(
			`post-jobs/?page=${page}&fields=id,title,state,type,min_experience,max_experience,min_salary,max_salary,employerImage,created_on`, {
			method: "GET"
		}).then(res => {
			setJobs(res?.data);
		}).catch(err => {
			console.log('err : ', err)
		})
		if (user?.role === 4) {
			axiosInstance(`can-applyjob/?user=${user?.id}&fields=id,job`, { method: "GET" })
				.then(res => {
					setSaved(res?.data?.results?.map(item => item.job))
				})
		}
	}

	const handleSave = (e, id) => {
		if (authenticated) {
			if (e.target.checked) {
				axiosInstance('can-applyjob/', { method: "POST", data: { "job": id, "status": "s", "user": user.id } })
			} else {
				axiosInstance(`can-applyjob/?user=${user.id}&status=s&job=${id}`, { method: "GET" })
					.then(res => {
						if (res.status === 200) {
							axiosInstance(`can-applyjob/${res?.data?.results?.[0]?.id}`, { method: "DELETE" })
						}
					}).catch(err => {
						console.log('err : ', err, err?.response?.data);
					})
			}
		} else history.push('/login')
	}

	return (
		<div className="section-full bg-white content-inner-2">
			<div className="container">
				<div className="d-flex job-title-bx section-head">
					<div className="mr-auto">
						<h2 className="m-b5">Recent Jobs</h2>
						<h6 className="fw4 m-b0">{jobs.pagination?.totalEntries} Recently Added Jobs</h6>
					</div>
					<div className="align-self-end">
						<Link to={"/browse-job-list"} className="site-button button-sm">Browse All Jobs <i className="fa fa-long-arrow-right"></i></Link>
					</div>
				</div>
				<div className="row">
					<div className={`col-lg-${authenticated ? "12" : "9"}`}>
						<ul className="post-job-bx browse-job">
							{!(jobs?.results?.length) && <div className="text-center">No records found</div>}
							{jobs?.results?.map((item, index) => {
								if (saved.includes(item.id)) return null;
								return (
									<li key={index}>
										<div className="post-bx" >
											<div className="d-flex m-b30">
												<div className="job-post-company">
													<span><img alt="" src={item?.image} /></span>
												</div>
												<div className="job-post-info">
													<h4><Link to={`/job-detail/${item.id}`}> {item?.title?.name} </Link></h4>
													<ul>
														<li><i className="fa fa-map-marker"></i> {item?.state?.name}, {item?.country?.name} </li>
														<li><i className="fa fa-bookmark-o"></i>{item?.type.map(rest => rest.name)}</li>
														<li><i className="fa fa-clock-o"></i> Published {date && getDuration(date)} ago</li>
													</ul>
												</div>
											</div>
											<div className="d-flex">
												<div className="job-time mr-auto">
													<Link to={"#"}><span>Experience: {item?.min_experience} - {item?.max_experience} Yrs</span></Link>
												</div>
												<div className="salary-bx">
													<span>{item?.country?.symbol} {+(item.min_salary)} - {item?.country?.symbol} {+(item.max_salary)}</span>
												</div>
											</div>
											<label className="like-btn">
												<input type="checkbox" onClick={(e) => handleSave(e, item.id)} />
												<span className="checkmark"></span>
											</label>
										</div>
									</li>
								)
							})}

						</ul>
						<div className="m-t30">
							<div className="d-flex">
								<button
									className="site-button button-sm mr-auto"
									disabled={jobs.pagination?.previousPage ? false : true}
									onClick={() => getData(jobs.pagination?.previousPage)}
									style={{ backgroundColor: jobs.pagination?.previousPage ? "#1d46f5" : "#8b99d5", cursor: jobs.pagination?.previousPage ? "pointer" : "not-allowed" }}
								>
									<i className="ti-arrow-left"></i> Prev
								</button>
								<button
									className="site-button button-sm"
									disabled={jobs.pagination?.nextPage ? false : true}
									onClick={() => getData(jobs.pagination?.nextPage)}
									style={{ backgroundColor: jobs.pagination?.nextPage ? "#1d46f5" : "#8b99d5", cursor: jobs.pagination?.nextPage ? "pointer" : "not-allowed" }}
								>
									Next <i className="ti-arrow-right"></i>
								</button>
							</div>
						</div>
					</div>
					{
						!authenticated &&
						<div className="col-lg-3">
							<div className="sticky-top">
								<div className="candidates-are-sys m-b30">
									<div className="candidates-bx">
										<div className="testimonial-pic radius"><img src={require("../../../images/testimonials/pic3.jpg")} alt="" width="100" height="100" /></div>
										<div className="testimonial-text">
											<p>I just got a job that I applied for via careerfy! I used the site all the time during my job hunt.</p>
										</div>
										<div className="testimonial-detail"> <strong className="testimonial-name">Richard Anderson</strong> <span className="testimonial-position">Nevada, USA</span> </div>
									</div>
								</div>
								<div className="quote-bx">
									<div className="quote-info">
										<h4>Make a Difference with Your Online Resume!</h4>
										<p>Your resume in minutes with JobBoard resume assistant is ready!</p>
										<Link to={"/register"} className="site-button">Create an Account</Link>
									</div>
								</div>
							</div>
						</div>
					}
				</div>
			</div>
		</div>
	)
}
export default Jobsection;